export const isValidColor = (color) => {
    if (!color) {
        return false;
    }

    const hexColorRegx = /^#[0-9a-f]{3,6}$/i;
    if (hexColorRegx.test(color.toString().toLowerCase())) {
        return true;
    }

    if (color.toString().toLowerCase().startsWith('rgb')) {
        return true;
    }

    return false;
};
